import { AdditionalInfoContent } from './additional-info-content'
import { AssetAllocationContent } from './asset-allocation'
import { FaqContent } from './faq-content'
import { SwitchElement } from './interface'
import { ProductPageComponentProps } from '../../interfaces'
import { PerformanceContent } from './performance/performance-content'
import { PerformanceLoading } from './performance/performance-content-loading'
interface SwitcherProps extends ProductPageComponentProps {
  element?: SwitchElement
}
//getSwitchContent(false, loadData, selectedElement, indexInfo, chartData)}
export const ProductDetailsTabSwitcher: React.FC<SwitcherProps> = ({
  element,
  store,
  productMetadata,
}) => {
  switch (element) {
    case SwitchElement.PERFORMANCE:
      return <PerformanceContent store={store} />
    case SwitchElement.ASSET_ALLOCATION:
      return <AssetAllocationContent store={store} productMetadata={productMetadata} />
    case SwitchElement.ADDITIONAL_INFO:
      return <AdditionalInfoContent store={store} productMetadata={productMetadata} />
    case SwitchElement.FAQ:
      return <FaqContent />

    default:
      return <PerformanceLoading />
  }
}
export default ProductDetailsTabSwitcher
